import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
  SET_STUDENTS_DATA_OTHER,
  SET_STUDENTS_LOADING,
  GET_STUDENT_TAB_DATA,
  ADD_STUDENT_DELETION,
  CLEAR_STUDENT_DELETIONS,
  GET_STUDENT_SCHOOL_YEARS,
  GET_STUDENT_SPECIALIST_TERMS,
  GET_STUDENT_PORTFOLIO_ITEM,
} from "../types";
import { getStudents } from "./list";

// Маппинг внутренних названий табов на API
export const TAB_MAPPING = {
  main: 'main',
  admission: 'admission',
  training: 'training',
  training_classes: 'training_classes',
  training_subgroups: 'training_subgroups',
  training_additional: 'training_additional',
  training_outclass: 'training_outclass',
  profotbor: 'profotbor',
  iot: 'iot',
  anthropometry: 'anthropometry',
  severity: 'severity',
  specialist_records: 'specialist_records',
  grades: 'grades',
  exams: 'exams',
  family: 'family',
  privileges: 'privileges',
  trusted_persons: 'trusted_persons',
  penalties: 'penalties',
  events: 'events',
  public_load: 'public_load',
  documents: 'documents',
  portfolio: 'portfolio',
  issued_documents: 'issued_documents',
  physical_training: 'physical_training',
  characteristic: 'characteristic',
  achievements: 'achievements',
  hobby: 'hobby',
  health: 'health'
};


export const getStudentOtherData = (entity, id) => async (dispatch, getState) => {
  const urlParams = new URLSearchParams(entity).toString();
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/students/${id}?${urlParams}`)
    dispatch({ type: SET_STUDENTS_DATA_OTHER, payload: data, entity })
  } catch (ERR) {
    // console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

export const updateStudentOtherData = (entity, id, data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.put(`/xp_personal_file/${entity}/${id}`, data)
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

export const createStudentOtherData = (entity, data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.post(`/xp_personal_file/${entity}`, data)
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

export const deleteStudentOtherData = (entity, id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.delete(`/xp_personal_file/${entity}/${id}`)
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// ==================== ПОЛУЧЕНИЕ ДАННЫХ СТУДЕНТА ПО ВКЛАДКАМ ====================

export const getStudentTable = (tab, studentId) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const apiTab = TAB_MAPPING[tab] || tab;
    const { data } = await api.get(`/students/${studentId}?tab=${apiTab}`);
    dispatch({ type: GET_STUDENT_TAB_DATA, payload: { tab, data: data.data || data } });
  } catch (ERR) {
    console.error('getStudentTable error:', ERR);
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// ==================== СОЗДАНИЕ СТУДЕНТА ====================

export const createStudentInfo = (formData) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });

    // formData структурирован по вкладкам (main, admission и т.д.)
    // Фильтруем пустые объекты/массивы
    const payload = {};

    Object.keys(formData).forEach(key => {
      const value = formData[key];
      if (value && typeof value === 'object') {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            payload[key] = value;
          }
        } else {
          if (Object.keys(value).length > 0) {
            payload[key] = value;
          }
        }
      }
    });

    await api.post('/students', payload);
    success = true;
    createNotification('success', 'Студент успешно создан');
    await dispatch(getStudents());
  } catch (ERR) {
    console.error('createStudentInfo error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка создания студента');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};

// ==================== ОБНОВЛЕНИЕ СТУДЕНТА ====================

export const updateStudentInfo = (studentId, tabData, deletions = {}) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });

    const payload = { ...tabData };

    // Добавляем поля удаления del_*
    Object.keys(deletions).forEach(apiTab => {
      if (deletions[apiTab] && deletions[apiTab].length > 0) {
        payload[`del_${apiTab}`] = deletions[apiTab];
      }
    });

    await api.put(`/students/${studentId}`, payload);
    success = true;
    createNotification('success', 'Данные успешно сохранены');
  } catch (ERR) {
    console.error('updateStudentInfo error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка сохранения');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};

// ==================== ТРЕКИНГ УДАЛЕНИЙ ====================

export const addStudentDeletion = (apiTab, itemId) => ({
  type: ADD_STUDENT_DELETION,
  payload: { apiTab, itemId }
});

export const clearStudentDeletions = () => ({
  type: CLEAR_STUDENT_DELETIONS
});

// ==================== CRUD ДЛЯ ВЛОЖЕННЫХ ТАБОВ EDUCATION ====================

// Маппинг типа вкладки на API endpoint
const EDUCATION_ENDPOINTS = {
  training_classes: 'classes',
  training_subgroups: 'subgroups',
  training_additional: 'additional',
  training_outclass: 'outclass',
  specialist_records: 'specialist_records',
  trusted_persons: 'trusted_persons',
  achievements: 'achievements',
  public_load: 'public_load',
  privileges: 'privileges',
  penalties: 'penalties',
  portfolio: 'portfolio',
  family: 'family',
  physical_training: 'physical_training',
  issued_documents: 'issued_documents',
};

// Создание записи в Education табах
export const createEducationRecord = (studentId, tabType, data) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const endpoint = EDUCATION_ENDPOINTS[tabType];
    await api.post(`/students/${studentId}/${endpoint}`, data);
    success = true;
    createNotification('success', 'Запись успешно создана');
    // Перезагружаем данные вкладки
    await dispatch(getStudentTable(tabType, studentId));
  } catch (ERR) {
    console.error('createEducationRecord error:', ERR);
    createNotification('error', ERR?.response?.data?.detail || 'Ошибка создания записи');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};

// Обновление записи в Education табах
export const updateEducationRecord = (studentId, tabType, recordId, data) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const endpoint = EDUCATION_ENDPOINTS[tabType];
    await api.put(`/students/${studentId}/${endpoint}/${recordId}`, data);
    success = true;
    createNotification('success', 'Запись успешно обновлена');
    // Перезагружаем данные вкладки
    await dispatch(getStudentTable(tabType, studentId));
  } catch (ERR) {
    console.error('updateEducationRecord error:', ERR);
    createNotification('error', ERR?.response?.data?.detail || 'Ошибка обновления записи');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};

// Удаление записи в Education табах
export const deleteEducationRecord = (studentId, tabType, recordId) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const endpoint = EDUCATION_ENDPOINTS[tabType];
    await api.delete(`/students/${studentId}/${endpoint}/${recordId}`);
    success = true;
    createNotification('success', 'Запись успешно удалена');
    // Перезагружаем данные вкладки
    await dispatch(getStudentTable(tabType, studentId));
  } catch (ERR) {
    console.error('deleteEducationRecord error:', ERR);
    createNotification('error', ERR?.response?.data?.detail || 'Ошибка удаления записи');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};

// Алиасы с более общими именами (покрывают все вкладки, не только education)
export const createStudentRecord = createEducationRecord;
export const updateStudentRecord = updateEducationRecord;
export const deleteStudentRecord = deleteEducationRecord;

// ==================== СПЕЦИАЛИЗИРОВАННЫЕ ЗАПРОСЫ ====================

// GET /students/{mid}/school_years — список учебных лет для вкладки УУД
export const getStudentSchoolYears = (mid) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/students/${mid}/school_years`);
    dispatch({ type: GET_STUDENT_SCHOOL_YEARS, payload: data.data || data });
  } catch (ERR) {
    console.error('getStudentSchoolYears error:', ERR);
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// GET /students/{mid}/specialist_records/terms — периоды для вкладки «Записи специалистов»
export const getStudentSpecialistRecordTerms = (mid) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/students/${mid}/specialist_records/terms`);
    dispatch({ type: GET_STUDENT_SPECIALIST_TERMS, payload: data.data || data });
  } catch (ERR) {
    console.error('getStudentSpecialistRecordTerms error:', ERR);
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// GET /students/{mid}/portfolio/{xp_key} — одна запись портфолио со всеми полями
export const getStudentPortfolioItem = (mid, xp_key) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/students/${mid}/portfolio/${xp_key}`);
    dispatch({ type: GET_STUDENT_PORTFOLIO_ITEM, payload: data.data || data });
  } catch (ERR) {
    console.error('getStudentPortfolioItem error:', ERR);
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};
export const createStudentPortfolioItem = (mid, data) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.post(`/students/${mid}/portfolio`, data);
  } catch (ERR) {
    console.error('getStudentPortfolioItem error:', ERR);
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// DELETE /students/{mid} — удаление личного дела учащегося
export const deleteStudent = (mid) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.delete(`/students/${mid}`);
    success = true;
    createNotification('success', 'Личное дело учащегося удалено');
    await dispatch(getStudents());
  } catch (ERR) {
    console.error('deleteStudent error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка удаления учащегося');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};